export default {

	category: ` 
		<div class="tt-suggestion tt-selectable">
			<a class="link js-highlightable" href="{{{Url}}}" data-test="category-link">{{{DisplayName}}}{{#Parent}} in <strong class="category">{{{Parent}}}</strong>{{/Parent}}</a>
		</div> 
	`,

	content: `
		<div class="tt-suggestion tt-selectable">
			<a class="link js-highlightable" href="{{{Url}}}" data-test="content-link">{{{DisplayName}}}</a>
		</div>
	`,

	empty: `
		<div class="tt-header">
			<h3 class="title">{{Title}}</h3>
			<p><i>{{Summary}}</i></p>
		</div>
	`,

	emptyProduct: `
		<div class="tt-header">
			<h3 class="title">{{Title}}</h3>
			<p class="summary">Your search for "{{{Query}}}" returned 0 products.</p>
		</div>
	`,

	header: `
		<div class="tt-header">
			<h3 class="title">{{{Title}}}</h3>
		</div>
	`,

	mobileCategories: `
		{{#HasResults}}
			<ul class="m-mobile-search__results__menu">
				{{#Results}}
				<li class="m-mobile-search__results__menu__item">
					<a class="m-mobile-search__results__menu__link" href="{{{Url}}}"><span class="js-highlightable">{{{DisplayName}}}</span>{{#Parent}} in <i>{{{Parent}}}</i>{{/Parent}}</a>
				</li>
				{{/Results}}
			</ul>
		{{/HasResults}}
		{{^HasResults}}
			<p class="m-mobile-search__results__empty">No categories found...</p>
		{{/HasResults}}
	`,

	mobileContent: `
		{{#HasResults}}
			<ul class="m-mobile-search__results__menu">
				{{#Results}}
				<li class="m-mobile-search__results__menu__item">
					<a class="m-mobile-search__results__menu__link" href="{{{Url}}}"><span class="js-highlightable">{{{DisplayName}}}</span></a>
				</li>
				{{/Results}}
			</ul>
		{{/HasResults}}
		{{^HasResults}}
			<p class="m-mobile-search__results__empty">No content found...</p>
		{{/HasResults}}
	`,

	mobileProducts: `
		{{#HasResults}}
			<p class="m-mobile-search__results__info">Showing 1-{{{TotalResults}}} of {{{MaxResults}}} products. <a href="/search?term={{Query}}">View all products &rsaquo;</a></p>
			<ul class="m-mobile-search__results__menu">
				{{#Results}}
				<li class="m-mobile-search__results__menu__item js-autocomplete-search-result-item" data-test="mobile-autocomplete-product">
					<div class="m-mobile-search__product m-mobile-search__product--mobile clearfix">
						<picture class="picture">
							<source srcset="{{ImageFilename}}?w=98&h=98&format=webp&quality=80" type="image/webp">
							<img class="m-mobile-search__product__image" src="{{ImageFilename}}?w=98&h=98&quality=80" loading="lazy" alt="{{{DisplayName}}}" />
						</picture>
						<div class="m-mobile-search__product__content">
							<p class="m-mobile-search__product__title"><span class="js-highlightable">{{{DisplayName}}}</span></p>
							{{#HasReviews}}
							<div class="m-mobile-search__product__rating">
								<div class="mStars tight">
									<div class="stars small">
										<div class="reveal" style="width: {{ReviewPerecentage}}%"></div>
										<p class="total">({{ReviewCount}})</p>
									</div>
								</div>
							</div>
							{{/HasReviews}}
							<div class="br-typeahead__merch-group">
								<p class="m-mobile-search__product__price {{#ShowSaleWasPrice}}m-mobile-search__product__price--sale{{/ShowSaleWasPrice}}">{{#HasVariants}}<span class="from">From</span> {{/HasVariants}}
								{{Price}}
								{{#ShowSaleWasPrice}}
								<span class="m-mobile-search__product__price__was"><span class="isOffscreen">Was </span>{{{OriginalPrice}}}</span>
								{{/ShowSaleWasPrice}}
								</p>
								{{#HasOverlays}}
								<div class="c-merch-overlay__group">
									{{#Overlays}}
										<merch-overlay inline shortText="{{ShortText}}" backgroundColor="{{Theme.BackgroundColor}}" textColor="{{Theme.TextColor}}" testName="search-box-overlay"></merch-overlay>
									{{/Overlays}}
								</div>
								{{/HasOverlays}}
							</div>
						</div>
						<a class="m-mobile-search__product__link js-autocomplete-search-result-link" href="{{{Url}}}" data-product-guid="{{Guid}}">View product</a>
					</div>
				</li>
				{{/Results}}
			</ul>
			<p class="m-mobile-search__results__all">
				<a class="formButton formButtonSmall" href="/search?term={{Query}}">View all {{{MaxResults}}} products for "{{Query}}"</a>
			</p>
		{{/HasResults}}
		{{^HasResults}}
			<p class="m-mobile-search__results__empty">No products found...</p>
		{{/HasResults}}
	`,

	pending: `
		<div class="tt-header">
			<h3 class="title">{{Title}}</h3>
			<div class="c-loader"><div><span class="u-visuallyhidden">Loading…</span></div></div>
			<p class="loading">Searching, please wait...</p>
		</div>
	`,

	product: `
		<div class="tt-suggestion tt-selectable js-autocomplete-search-result-item" data-test="desktop-autocomplete-product">
			<a class="product" href="{{{Url}}}" data-test="{{{DisplayName}}}" data-product-guid="{{Guid}}">
				<picture class="picture">
					<source srcset="{{ImageFilename}}?w=98&h=98&format=webp&quality=80" type="image/webp">
					<img class="image" src="{{ImageFilename}}?w=98&h=98&quality=80" alt="{{{DisplayName}}}" loading="lazy" width="98" height="98" />
				</picture>
				<div class="content">
					<h3 class="title js-highlightable">{{{DisplayName}}}</h3>
					{{#HasReviews}}
					<div class="rating">
						<div class="mStars tight">
							<div class="stars small">
								<div class="reveal" style="width: {{ReviewPerecentage}}%"></div>
								<p class="total">({{ReviewCount}})</p>
							</div>
						</div>
					</div>
					{{/HasReviews}}
					<div class="br-typeahead__merch-group">
						<p class="price {{#ShowSaleWasPrice}}price--sale{{/ShowSaleWasPrice}}">
						{{#HasVariants}}<span class="from">From</span> {{/HasVariants}}
						<span data-test="search-box-price">{{Price}}</span>
						{{#ShowSaleWasPrice}}
						<span class="price__was" data-test="search-box-was-price"><span class="isOffscreen">Was </span>{{{OriginalPrice}}}</span>
						{{/ShowSaleWasPrice}}
						</p>
						{{#HasOverlays}}
						<div class="c-merch-overlay__group">
							{{#Overlays}}
								<merch-overlay inline shortText="{{ShortText}}" backgroundColor="{{Theme.BackgroundColor}}" textColor="{{Theme.TextColor}}" testName="search-box-overlay"></merch-overlay>
							{{/Overlays}}
						</div>
						{{/HasOverlays}}
					</div>
				</div>
			</a>
		</div>
	`,

	productsFooter: `
		<div class="tt-footer">
			<a class="link" href="{{Url}}" data-test="view-all-products">View all <span data-test="total-product-results">{{{Count}}}</span> products for "{{{Query}}}"</a>
		</div>
	`,

	productsHeader: `
		<div class="tt-header">
			<h3 class="title">{{{Title}}}</h3>
			<p class="summary">Your search for "{{{Query}}}" returned {{{Count}}} products. <a href="{{{Url}}}">View all products <span class="tt-header__link-arrow">&rsaquo;</span></a></p>
		</div>
	`,

	addressSuggestion: `
		<div class="tt-suggestion">
			<button type="button" data-typeahead-id="{{Id}}" data-typeahead-next="{{Next}}" class="tt-suggestion__button js-highlightable" data-test="address-suggestion">{{ Text }}</button> 
		</div>`

};
